module.exports = __webpack_public_path__ + "img/brand-icon2.e541b201.jpg";